import { Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IParams {
    onClick(): void;
}

export const CancelButton = (props: IParams) => {
    const { onClick } = props;
    const { t } = useTranslation("order");

    return (
        <Link
            aria-label={t("cancelBroadbandOffer")}
            component="button"
            underline="always"
            width="fit-content"
            onClick={onClick}
        >
            <Typography align="center" color="primary">
                {t("cancelBroadbandOffer")}
            </Typography>
        </Link>
    );
};
